import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      <SEO
        title="About"
        path="/about"
        description="Heirloom Stories Studio exists to guide the conversations most families never think to have — until it's too late. We believe voices matter more than photos."
      />
      <Navbar />

      <section className="pt-32 sm:pt-40 pb-24 sm:pb-32">
        <div className="max-w-4xl mx-auto px-6 sm:px-12">
          <div className="text-center mb-16 sm:mb-20">
            <p className="overline mb-6">About Us</p>
            <h1 data-testid="about-title" className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl font-medium text-[#1C1917] leading-tight mb-6">
              This is not a gift.<br />
              <span className="italic text-[#78716C]">It's a responsibility.</span>
            </h1>
          </div>

          <div className="space-y-12 text-base sm:text-lg text-[#57534E] leading-relaxed">
            <p>
              At some point, every adult child realizes this isn't something parents will initiate on their own. Legacy doesn't preserve itself.
            </p>
            <p>
              We exist to guide the conversations most families never think to have — until it's too late.
            </p>

            <div className="border-t border-[#E7E5DF] pt-12">
              <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-medium text-[#1C1917] mb-8">
                What We Believe
              </h2>
              <div className="space-y-8">
                {[
                  { title: 'Voices matter more than photos', desc: 'A photograph captures a moment. A voice captures a soul. We prioritize preserving how your loved ones sound, think, and feel.' },
                  { title: 'Stories deserve ceremony', desc: 'This isn\'t content creation. It\'s preservation. We treat every session with the reverence it deserves.' },
                  { title: 'Simplicity is luxury', desc: 'Our process is designed to be effortless for families. We handle everything — you just show up and be present.' },
                  { title: 'Once is enough', desc: 'We don\'t believe in subscriptions or upsells. You do this once. We help you do it right.' },
                ].map((item, i) => (
                  <div key={i} data-testid={`belief-${i}`}>
                    <h3 className="font-['Cormorant_Garamond'] text-xl sm:text-2xl font-medium text-[#1C1917] mb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#57534E]">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-[#E7E5DF] pt-12">
              <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl font-medium text-[#1C1917] mb-8">
                Our Promise
              </h2>
              <p className="text-[#57534E] mb-6">
                Every heirloom we create is handled with the same care we would give our own family's story. From the intake call to the final delivery, your loved one's legacy is in thoughtful hands.
              </p>
              <p className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl italic text-[#78716C]">
                "This is their story. Keep it close."
              </p>
            </div>
          </div>

          <div className="text-center mt-16 sm:mt-20">
            <Link
              to="/contact"
              data-testid="about-cta"
              className="inline-flex items-center justify-center bg-[#1C1917] text-[#FCFBF9] hover:bg-[#322f2d] px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300 gap-2"
            >
              Begin Your Story <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
